/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodBankInvestigationList from './blood-bank-investigation-list';
import BloodBankInvestigationListDetail from './blood-bank-investigation-list-detail';
import BloodBankInvestigationListUpdate from './blood-bank-investigation-list-update';
import BloodBankInvestigationListDeleteDialog from './blood-bank-investigation-list-delete-dialog';

const BloodBankInvestigationListRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodBankInvestigationList />} />
    <Route path="new" element={<BloodBankInvestigationListUpdate />} />
    <Route path=":id">
      <Route index element={<BloodBankInvestigationListDetail />} />
      <Route path="edit" element={<BloodBankInvestigationListUpdate />} />
      <Route path="delete" element={<BloodBankInvestigationListDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodBankInvestigationListRoutes;
